function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { elo as theme } from '../../themes';
export default (function () {
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  var isTablet = useMediaQuery({
    query: theme.breakpoints.tablet
  });
  var _useState = useState([]),
    toasts = _useState[0],
    setToasts = _useState[1];
  var handleDismiss = function handleDismiss(toast) {
    _removeToast(toast.id);
    return toast == null ? void 0 : toast.onDismiss == null ? void 0 : toast.onDismiss();
  };
  var handleActionClick = function handleActionClick(toast) {
    _removeToast(toast.id);
    return toast == null ? void 0 : toast.onActionClick();
  };
  var calcStackToastPosition = function calcStackToastPosition(arrayStack) {
    return arrayStack.reduce(function (previusToast, currentToast) {
      var _currentToast$ref;
      return previusToast + (currentToast == null ? void 0 : (_currentToast$ref = currentToast.ref) == null ? void 0 : _currentToast$ref.offsetHeight);
    }, 0);
  };
  var _addToast = function addToast(toast) {
    var newToast = _extends({}, toast, {
      id: Date.now(),
      action: toast == null ? void 0 : toast.action,
      actionLink: toast == null ? void 0 : toast.actionLink,
      actionTarget: toast == null ? void 0 : toast.actionTarget,
      autoClose: toast.hasOwnProperty('autoClose') ? toast.autoClose : true,
      seconds: toast.hasOwnProperty('seconds') ? toast.seconds : 6,
      variant: toast.hasOwnProperty('variant') ? toast.variant : 'informative',
      disableButtonClose: toast.hasOwnProperty('disableButtonClose') ? toast.disableButtonClose : false
    });
    setToasts(function (prevState) {
      return [newToast].concat(prevState);
    });
    return newToast.id;
  };
  var _removeToast = function removeToast(toastId) {
    setToasts(function (prevState) {
      return prevState.filter(function (t) {
        return t.id !== toastId;
      });
    });
  };
  var getOffsetPositionY = function getOffsetPositionY() {
    if (isMobile) {
      return 50;
    }
    if (isTablet) {
      return 65;
    }
    return 80;
  };
  useEffect(function () {
    toasts.forEach(function (toast, index) {
      var arrayStack = [].concat(toasts);
      var positionY = calcStackToastPosition(arrayStack.slice(0, index));
      toast.ref.style.transform = "translateY(" + (positionY + getOffsetPositionY()) + "px)";
    });
  }, [toasts]);
  useEffect(function () {
    window.PLURALL_ELO_TOAST_CONTAINER = {
      addToast: function addToast(toast) {
        return _addToast(toast);
      },
      removeToast: function removeToast(toastId) {
        return _removeToast(toastId);
      }
    };
  }, []);
  return {
    toasts: toasts,
    handleDismiss: handleDismiss,
    handleActionClick: handleActionClick
  };
});